import React, { useEffect, useState } from "react";
import "./List.scss";
import {
  loadRatingNumber,
  loadRatingstar,
  showPriceValue,
} from "../../../../Helpers/SettingHelper";
import WifiIcon from "../../../../../common/images/wifi.svg";
import { Button, CircularProgress, Divider } from "@mui/material";
import {
  handleStayApiCall,
  // handleStayApiCall,
} from "../../../../Helpers/apiHelper";
import Header from "../../../../Layout/Header";
import Footer from "../../../../Layout/Footer";
import SearchComponent from "../SearchComponent/SearchComponent";
import { format } from "date-fns";
import Carousel from "../../../../Customerpackage/CustomerPackageDetails/RoomSelection/Carousel";
import { getHotelImages } from "../../../../../utils/util";
import SortBySheet from "./SortBySheet/SortBySheet";
import FilterSheet from "./FilterSheet/FilterSheet";
import { FilterIcon } from "../../../../../common/IconList/IconList";
import { BottomSheet } from "react-spring-bottom-sheet";

export const List = (props) => {
  const propsData = props.location.state || {};
  const [state, setState] = useState(() => ({
    destinationCity: propsData.destinationCity || "",
    hotelDestinationList: propsData.hotelDestinationList || [],
    adults: propsData.adults || 1,
    child: propsData.child || 0,
    room_count: propsData.room_count || 1,
    rooms: propsData.rooms || [{ adults: 1, child: [] }],
    start_date: propsData.start_date || null,
    end_date: propsData.end_date || null,
    dateRange: propsData.dateRange || {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
    destinationCountry: propsData.destinationCountry || "",
    currentCurrency: propsData.currentCurrency || "SGD",
    currencyRate: propsData.currencyRate || 1,
    tempHotelList: propsData.tempHotelList || [],
    totalPassengersCount: propsData.totalPassengersCount || 1,
    childAgeList: propsData.childAgeList || [],
  }));
  const [priceVal, setPriceVal] = useState([0, 1000]);
  const [stayList, setStayList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [amenities, setAmenities] = useState([]);
  const [sortOption, setSortOption] = useState("");
  const [showFilterSheet, setShowFilterSheet] = useState(false);
  const [filterData, setFilterData] = useState({
    amenities: [],
  });
  const [showSortBySheet, setShowSortBySheet] = useState(false);
  const isMobile = window.innerWidth <= 480;
  useEffect(() => {
    getStayList();
  }, []);

  useEffect(() => {
    applyFilter();
  }, [priceVal, filterData]);

  useEffect(() => {
    getAmenities();
  }, [stayList]);

  const getAmenities = () => {
    const amenities =
      stayList?.length > 0
        ? [...new Set(stayList.flatMap((item) => item.hotel_amenities))]
        : [];

    setAmenities(amenities);
  };

  const applyFilter = () => {
    let temp = stayList.filter(
      (room) =>
        room.room_charge > priceVal[0] &&
        room.room_charge < priceVal[1] &&
        (filterData.amenities.length > 0
          ? room.hotel_amenities.some((a) => filterData.amenities.includes(a))
          : true)
    );
    setFilteredList(temp);
  };

  const getStayList = async () => {
    if (!state.destinationCity && !state.destinationCountry) {
      setError(true);
      return false;
    }
    setIsLoading(true);

    const startDate = format(new Date(state.start_date), "yyyy-MM-dd");
    const endDate = format(new Date(state.end_date), "yyyy-MM-dd");
    try {
      const response = await handleStayApiCall(
        "get",
        `getList?city=${state.destinationCity}&country=${
          state.destinationCountry
        }&adults=${state.adults}&child=${
          state.child
        }&start_date=${startDate}&end_date=${endDate}&passenger_data=${JSON.stringify(
          state?.rooms
        )}`
      );

      setStayList(response.data?.data || []);
      setFilteredList(response.data?.data || []);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const searchDestinations = (event) => {
    const { value } = event.target;

    setState((prev) => {
      const filteredDestinations =
        value.length >= 3
          ? state.hotelDestinationList.filter((item) =>
              item.city_name.toLowerCase().includes(value.toLowerCase())
            )
          : [];

      return {
        ...prev,
        destinationCity: value,
        tempHotelList: filteredDestinations,
      };
    });
    setError(false);
  };

  const sateValChange = (field, value) => {
    if (field === "currentCurrency") {
      setState({ ...state, currentCurrency: value });
    }
  };

  const selectHotels = (hotel) => {
    const searchData = {
      ...state,
      selectedHotel: hotel || {},
      hotelMinPrice: hotel?.room_charge || null,
      prevPath: props.location.pathname,
    };

    props.history.push({
      pathname: `/stay/${searchData.destinationCity}/${hotel?.hotel_name}`,
      state: searchData,
    });
  };

  const handleAmenities = (val) => {
    let temp = filterData.amenities;
    const index = filterData.amenities.indexOf(val);
    if (index !== -1) {
      temp.splice(index, 1);
    } else {
      temp.push(val);
    }
    setFilterData((prev) => ({ ...prev, amenities: temp }));
  };

  const clearAll = () => {
    setFilterData({ amenities: [] });
    setPriceVal([0, 1000]);
  };

  const handleSortBySheet = (ev) => {
    if (isMobile) {
      ev?.preventDefault();
      setShowSortBySheet(true);
      return;
    }
  };

  const handleSort = (ev) => {
    setSortOption(ev.target.value);
    if (isMobile) {
      setShowSortBySheet(false);
    }
  };

  return (
    <>
      <Header {...props} sateValChange={sateValChange} />
      <SearchComponent
        state={state}
        setState={setState}
        searchHotels={getStayList}
        searchDestinations={searchDestinations}
        cityError={error}
        showOnlyCity={isMobile}
      />
      {isLoading && (
        <div className="spinner">
          <CircularProgress />
        </div>
      )}
      <div className="stay-list-main">
        <div className="stay-list-main__content">
          <div className="stay-list-main__content__row">
            <div className="stay-list-main__content__row__col1">
              <FilterSheet
                clearAll={clearAll}
                filterData={filterData}
                handleAmenities={handleAmenities}
                state={state}
                amenities={amenities}
                priceVal={priceVal}
                setPriceVal={setPriceVal}
              />
            </div>
            <div className="stay-list-main__content__row__col2">
              <div className="stay-list-main__content__row__col2__subheader">
                <div className="stay-list-main__content__row__col2__subheader__total">
                  {filteredList?.length} results{" "}
                  <span>“{state.destinationCountry}”</span>
                </div>
                <div className="stay-list-main__content__row__col2__subheader__sort">
                  <div className="filter-row-new">
                    <h5>Sort By</h5>
                    <div>
                      <select
                        value={sortOption}
                        onClick={handleSortBySheet}
                        onMouseDown={handleSortBySheet}
                        onChange={handleSort}
                      >
                        <option value="">Recommended</option>
                        <option value="lowToHigh">Price: Low to High</option>
                        <option value="highToLow">Price: High to Low</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="stay-list-main__content__row__col2__list">
                {[...filteredList]
                  .sort((a, b) =>
                    sortOption === "lowToHigh"
                      ? a.room_charge - b.room_charge
                      : sortOption === "highToLow"
                      ? b.room_charge - a.room_charge
                      : 0
                  )
                  ?.map((stay, index) => (
                    <div
                      key={index}
                      className="stay-list-main__content__row__col2__list__card"
                      onClick={() => isMobile && selectHotels(stay)}
                    >
                      <div className="stay-list-main__content__row__col2__list__card__col1">
                        <Carousel
                          width={isMobile ? "92vw" : "23.5vw"}
                          show={false}
                          images={getHotelImages(stay?.images)}
                          room={stay}
                          height={"250px"}
                          showBottomGallery={false}
                        />
                      </div>
                      <div className="stay-list-main__content__row__col2__list__card__col2">
                        <div className="stay-list-main__content__row__col2__list__card__col2__name">
                          {stay.hotel_name}
                        </div>
                        {!isMobile && (
                          <div className="stay-list-main__content__row__col2__list__card__col2__review">
                            {loadRatingNumber(stay.rating)}&nbsp;
                            <span className="star-rating">
                              {loadRatingstar(stay.rating, "hotel")}
                            </span>
                          </div>
                        )}
                        <div className="stay-list-main__content__row__col2__list__card__col2__loc">
                          {stay.address}, {stay.city_name}
                        </div>
                        {isMobile && (
                          <div className="stay-list-main__content__row__col2__list__card__col2__amenities">
                            {stay.hotel_amenities &&
                              stay.hotel_amenities
                                ?.slice(0, isMobile ? 1 : 5)
                                ?.map((amenity, index) => (
                                  <div
                                    className="stay-list-main__content__row__col2__list__card__col2__row__col1__amenity__val"
                                    key={index}
                                  >
                                    <img src={WifiIcon} alt="WifiIcon" />
                                    {amenity}
                                  </div>
                                ))}
                            <span>
                              {stay.hotel_amenities?.length}+ amenities
                            </span>
                          </div>
                        )}
                        <div className="stay-list-main__content__row__col2__list__card__col2__row">
                          <div className="stay-list-main__content__row__col2__list__card__col2__row__col1">
                            <div className="stay-list-main__content__row__col2__list__card__col2__row__col1__amenity">
                              {!isMobile &&
                                stay.hotel_amenities &&
                                stay.hotel_amenities
                                  ?.slice(0, isMobile ? 2 : 5)
                                  ?.map((amenity, index) => (
                                    <div
                                      className="stay-list-main__content__row__col2__list__card__col2__row__col1__amenity__val"
                                      key={index}
                                    >
                                      <img src={WifiIcon} alt="WifiIcon" />
                                      {amenity}
                                    </div>
                                  ))}
                              {isMobile && (
                                <div className="stay-list-main__content__row__col2__list__card__col2__review">
                                  {loadRatingNumber(stay.rating)}&nbsp;
                                  <span className="star-rating">
                                    {loadRatingstar(stay.rating, "hotel")}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="stay-list-main__content__row__col2__list__card__col2__row__col2">
                            <div className="stay-list-main__content__row__col2__list__card__col2__row__col2__psCount">
                              starting from
                            </div>
                            <div className="stay-list-main__content__row__col2__list__card__col2__row__col2__price">
                              {showPriceValue(
                                stay.room_charge,
                                state.currentCurrency,
                                state.currencyRate
                              )}
                            </div>
                            {/* <div className="stay-list-main__content__row__col2__list__card__col2__row__col2__days">
                              2 nights stay
                            </div> */}
                            {!isMobile && (
                              <Button
                                variant="contained"
                                onClick={() => selectHotels(stay)}
                              >
                                Select room
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              {filteredList?.length === 0 && !isLoading && (
                <div className="stay-list-main__content__row__col2__noData">
                  No data found!
                </div>
              )}
            </div>
          </div>
        </div>
        {isMobile && (
          <div
            className="stay-list-main__filterBtn"
            onClick={() => setShowFilterSheet(true)}
          >
            <FilterIcon /> Filters
          </div>
        )}
      </div>
      <SortBySheet
        showSortBySheet={showSortBySheet}
        sortOption={sortOption}
        setShowSortBySheet={setShowSortBySheet}
        handleSort={handleSort}
      />
      <BottomSheet
        open={showFilterSheet}
        onDismiss={() => setShowFilterSheet(false)}
        className="priceBreakdown__bottomSheetMain"
      >
        <FilterSheet
          clearAll={clearAll}
          filterData={filterData}
          handleAmenities={handleAmenities}
          state={state}
          amenities={amenities}
          priceVal={priceVal}
          setPriceVal={setPriceVal}
        />
        <Button
          variant="contained"
          className="searchBtn"
          onClick={() => setShowFilterSheet(false)}
        >
          Search
        </Button>
      </BottomSheet>
      <Footer />
    </>
  );
};

export default List;
